import { render } from "./counterSvg.vue?vue&type=template&id=ea7890a6&scoped=true"
import script from "./counterSvg.vue?vue&type=script&lang=js"
export * from "./counterSvg.vue?vue&type=script&lang=js"

import "./counterSvg.vue?vue&type=style&index=0&id=ea7890a6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Sebastian\\Desktop\\-taptasty-order\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea7890a6"]])

export default __exports__